import {Comparator} from "../../types/GenericTypes";
import {SecurityTradingSystemIndicators} from "../models/SecurityTradingSystemIndicators";
import {TradingSystemStatus} from "../models/TradingSystemStatus";

export function orderIndicators(): Comparator<SecurityTradingSystemIndicators> {
    return (a, b) => {
        const aRank = tradingSystemIndicatorRank(a);
        const bRank = tradingSystemIndicatorRank(b);
        const rankCompare = bRank - aRank;
        if (rankCompare === 0) {
            return a.code.localeCompare(b.code);
        } else {
            return rankCompare;
        }
    };
}

export function tradingSystemIndicatorRank(system: SecurityTradingSystemIndicators): number {
    const littActive = (system.littStatus === TradingSystemStatus.ACTIVE) ? 7 : 0;
    const littApproaching = (system.littStatus === TradingSystemStatus.APPROACHING) ? 1 : 0;

    return littActive + littApproaching;
}
